import i18n from 'i18n-literally'

import { Typography } from '@mui/material'

const Label = () => (
  <Typography
    color="secondary"
    component="span"
    variant="button"
    sx={{
      display: 'inline',
    }}
  >
    {i18n`harvest group`}
  </Typography>
)

export default Label
